/**
 * Thin wrappers over the existing fetchAPI that hit the three
 * discovery endpoints. Reused by hooks + tests.
 */

import { fetchAPI } from '../api/client';
import type { PluginMenuEntry, PluginPage, PluginSurface } from './types';

// Both discovery calls are AMBIENT: they fire on every page mount to decorate
// the nav and register optional routes. `suppressAuthRedirect` keeps a 401
// from them out of the session-teardown path — before this, a plugin endpoint
// returning 401 (unauthenticated boot, plugin subsystem disabled, a plugin
// route erroring) logged the user out of whatever page they were on. The
// page's own data fetch still 401s and redirects correctly when the session
// really is gone.
export async function fetchPluginMenu(surface: PluginSurface): Promise<PluginMenuEntry[]> {
  return fetchAPI<PluginMenuEntry[]>(`/api/plugins/menu?surface=${surface}`, {
    suppressAuthRedirect: true,
  });
}

export async function fetchPluginPages(): Promise<PluginPage[]> {
  return fetchAPI<PluginPage[]>('/api/plugins/pages', { suppressAuthRedirect: true });
}
